"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

require("../../assets/css/components/card/card.css");

var _reactRouter = require("react-router");

var _Icone = require("../elements/Icone");

var _Icone2 = _interopRequireDefault(_Icone);

var _Form = require("../form/Form");

var _Form2 = _interopRequireDefault(_Form);

var _Progress = require("../progress/Progress");

var _Progress2 = _interopRequireDefault(_Progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Card = function (_React$Component) {
    _inherits(Card, _React$Component);

    function Card(props) {
        _classCallCheck(this, Card);

        var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));

        _this.getCard = function () {
            if (_this.props.form) {
                return _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        _Form2.default,
                        { onSubmit: _this.props.onSubmit, loading: _this.props.loading },
                        _this.getLoading(),
                        _react2.default.createElement(
                            "div",
                            { className: "mdl-card__supporting-text " + (_this.props.noPadding ? "no-padding" : "") },
                            _this.props.children
                        ),
                        _this.hasAction()
                    )
                );
            } else {
                return _react2.default.createElement(
                    "div",
                    null,
                    _this.getLoading(),
                    _react2.default.createElement(
                        "div",
                        { className: "mdl-card__supporting-text " + (_this.props.noPadding ? "no-padding" : "") },
                        _this.props.children
                    ),
                    _this.hasAction()
                );
            }
        };

        _this.getContent = function () {
            return _react2.default.createElement(
                "div",
                { ref: function ref(card) {
                        return _this.card = card;
                    },
                    className: "mdl-cell mdl-cell--" + (_this.props.width ? _this.props.width : 12) + "-col mdl-card mdl-cell--" + (_this.props.tablet ? _this.props.tablet : 8) + "-col-tablet mdl-cell--" + (_this.props.phone ? _this.props.phone : 10) + "-col-phone mdl-shadow--2dp " + (_this.props.centered ? "mdl-cell--middle" : "") + " " + _this.props.className },
                _react2.default.createElement(
                    "div",
                    {
                        className: 'mdl-card__title ' + (_this.props.borderBottom ? "mdl-card--border " : "") + (_this.props.colorHeader || "") + (_this.props.tabOptions ? ' mdl-card-tab' : "") + (_this.props.tools ? " mdl-card--tools " : "") },
                    _react2.default.createElement(
                        "h2",
                        { className: "mdl-card__title-text" },
                        _this.props.titulo
                    ),
                    _this.hasDescription(),
                    _this.getTab(),
                    _react2.default.createElement(
                        "div",
                        { className: "mdl-card__menu" },
                        _this.hasTools()
                    )
                ),
                _this.hasDivider(),
                _this.getCard()
            );
        };

        _this.state = {
            scroll: false,
            sizeScroll: 0,
            scrollRight: 0,
            tabOptions: null
        };

        _this.onScrollRight = _this.onScrollRight.bind(_this);
        _this.onScrollLeft = _this.onScrollLeft.bind(_this);

        return _this;
    }

    _createClass(Card, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.tabOptions) {
                window.addEventListener("resize", function () {
                    _this2.calcWidth();
                });
                this.calcWidth();
            }
        }
    }, {
        key: "calcWidth",
        value: function calcWidth() {
            var scroll = this.card.querySelector('.tab-options').scrollWidth;
            _reactDom2.default.findDOMNode(this.card).querySelector('.tab-options').style.marginLeft = '0px';
            this.setState({
                displayButtons: scroll > this.card.scrollWidth,
                scroll: scroll > this.card.scrollWidth,
                sizeScroll: scroll - this.card.scrollWidth,
                scrollRight: 0,
                tabOptions: _reactDom2.default.findDOMNode(this.card).querySelector('.tab-options')
            });
        }
    }, {
        key: "hasDivider",
        value: function hasDivider() {
            if (this.props.divider) return _react2.default.createElement("div", { className: "box-divider" });
        }
    }, {
        key: "hasDescription",
        value: function hasDescription() {
            if (this.props.descricao) return _react2.default.createElement(
                "small",
                { "aria-hidden": this.props.hiddenDescription },
                this.props.descricao
            );
        }
    }, {
        key: "hasTools",
        value: function hasTools() {
            if (this.props.tools) {
                return _react2.default.createElement(
                    "div",
                    { className: "tool-fixed" },
                    this.props.tools
                );
            }
        }
    }, {
        key: "hasAction",
        value: function hasAction() {
            if (this.props.actions) return _react2.default.createElement(
                "div",
                { className: "mdl-card__actions mdl-card--border" },
                this.props.actions
            );
        }
    }, {
        key: "mapOptions",
        value: function mapOptions() {
            return this.props.tabOptions.map(function (o, i) {
                return _react2.default.createElement(
                    _reactRouter.Link,
                    {
                        className: "mdl-tabs__tab" + (window.location.pathname === o.to || o.active ? " is-active" : ""),
                        key: "tab-" + i, to: o.to, onClick: o.onClick },
                    o.text
                );
            });
        }
    }, {
        key: "getTab",
        value: function getTab() {
            var _this3 = this;

            if (this.props.tabOptions) {
                return _react2.default.createElement(
                    "div",
                    { className: "mtd-tabs card-tabs", ref: function ref(tab) {
                            return _this3.tab = tab;
                        } },
                    this.getLeftButton(),
                    _react2.default.createElement(
                        "div",
                        { className: "tab-options" + (this.props.tabOptions ? " tab-scroll" : "") },
                        this.mapOptions()
                    ),
                    this.getRightButton()
                );
            }
        }
    }, {
        key: "getLeftButton",
        value: function getLeftButton() {
            if (this.state.displayButtons) return _react2.default.createElement(
                "button",
                { "aria-hidden": "true", onClick: this.onScrollLeft,
                    className: "mtd-tabs-button left" + (this.state.scrollRight > 0 ? ' active' : "") },
                _react2.default.createElement(_Icone2.default, { icone: "keyboard_arrow_left" })
            );
        }
    }, {
        key: "getRightButton",
        value: function getRightButton() {
            if (this.state.displayButtons) return _react2.default.createElement(
                "button",
                { "aria-hidden": "true", onClick: this.onScrollRight,
                    className: "mtd-tabs-button right" + (this.state.scrollRight < this.state.sizeScroll ? ' active' : '') },
                _react2.default.createElement(_Icone2.default, { icone: "keyboard_arrow_right" })
            );
        }
    }, {
        key: "onScrollRight",
        value: function onScrollRight() {
            var marginLeft = this.state.tabOptions.style.marginLeft;
            marginLeft = Number(marginLeft.replace('px', ''));
            if (this.state.sizeScroll > -marginLeft + 126) {
                this.setState({
                    scrollRight: -marginLeft + 126
                });
                _reactDom2.default.findDOMNode(this.card).querySelector('.tab-options').style.marginLeft = marginLeft - 126 + 'px';
            } else {
                this.setState({
                    scrollRight: this.state.sizeScroll
                });
                _reactDom2.default.findDOMNode(this.card).querySelector('.tab-options').style.marginLeft = -this.state.sizeScroll + 'px';
            }
        }
    }, {
        key: "onScrollLeft",
        value: function onScrollLeft() {
            var marginLeft = this.state.tabOptions.style.marginLeft;
            marginLeft = Number(marginLeft.replace('px', ''));
            if (marginLeft + 126 < 0) {
                this.setState({
                    scrollRight: this.state.scrollRight - 126
                });
                _reactDom2.default.findDOMNode(this.card).querySelector('.tab-options').style.marginLeft = marginLeft + 126 + 'px';
            } else {
                this.setState({
                    scrollRight: 0
                });
                _reactDom2.default.findDOMNode(this.tab).querySelector('.tab-options').style.marginLeft = '0px';
            }
        }
    }, {
        key: "getLoading",
        value: function getLoading() {
            if (this.props.displayLoading) {
                return _react2.default.createElement(_Progress2.default, { position: this.props.loadingPosition || "bottom" });
            }
        }
    }, {
        key: "render",
        value: function render() {
            return this.getContent();
        }
    }]);

    return Card;
}(_react2.default.Component);

exports.default = Card;


Card.propTypes = {
    borderBottom: _propTypes2.default.bool,
    titulo: _propTypes2.default.string,
    colorHeader: _propTypes2.default.string,
    descricao: _propTypes2.default.string,
    colorBody: _propTypes2.default.string,
    tools: _propTypes2.default.element,
    divider: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/card/Card.js
// module id = 343
// module chunks = 0